/**
 * Copies text to the clipboard using the Clipboard API.
 * Returns a boolean indicating success or failure.
 *
 * @param value - The text to copy to the clipboard
 * @returns Promise<boolean> - true if successful, false otherwise
 */
export async function copyToClipboard(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}
